import { BestFareResult } from '@core/bff';
import { BookerResponse, MOCK_BOOKER_RESPONSE } from '@shared/booker';
import { RecentAirSearch } from '@shared/types';
import { startOfToday } from 'date-fns';

export enum BookerAirActiveDatePicker {
  DEPART = 'depart',
  RETURN = 'return',
}

export type CustomBookerAirFareForm = Omit<
  RecentAirSearch,
  'departDate' | 'returnDate' | 'destinationCode' | 'originCode'
> & {
  departDate?: string[] | Date[];
  returnDate?: string[] | Date[];
  originCode?: string[];
  destinationCode?: string[];
};

export interface BookerAirState {
  bookerAirFaresForm: CustomBookerAirFareForm;
  apiFailed: boolean;
  months: any[];
  content: BookerResponse;
  calendarMessage: string;
  monthPricingCache: {
    [YearMonthKey: string]: BestFareResult;
  };
  scheduleEnabled: boolean;
  pricingEnabled: boolean;
  focusedInput: 'depart' | 'return';
}

export const bookerAirComponentInitialState: BookerAirState = {
  bookerAirFaresForm: {
    intineraryType: undefined,
    originCode: [],
    destinationCode: [],
    departDate: [startOfToday()],
    fare: undefined,
    ADT: 1,
    CHD: 0,
    INF: 0,
  },
  apiFailed: false,
  months: [],
  calendarMessage: null,
  content: MOCK_BOOKER_RESPONSE,
  monthPricingCache: {},
  scheduleEnabled: false,
  pricingEnabled: false,
  focusedInput: 'depart',
};
